import { toaster } from "rsuite";
import { showToast } from "../../components/toast.component";
import { AppRouteApi } from "../../config/appRoute";
import {
  ApiResponseContainer,
  ApiSchemaGetImportStatus,
} from "../../models/api";
import { AxiosAuth } from "../axios";

async function saveTemplateData(apiURL: string, data: unknown) {
  try {
    const response = await AxiosAuth.post<ApiResponseContainer<string>>(
      apiURL,
      data
    );
    if (response.data.isSuccess) {
      const toastId = showToast(
        "Saving data. Please wait...",
        "info",
        "topCenter",
        0,
        true
      );
      const importKey = response.data.data!;
      shortPollImportStatus(importKey, toastId);
    } else {
      showToast("An error occurred!", "error");
    }
  } catch (error: any) {
    const defaultMessage = "An error occurred!";
    const errorMessage = JSON.parse(error?.message);
    showToast(
      errorMessage?.data?.message || defaultMessage,
      "error",
      "topCenter",
      0,
      true
    );
  }
}

async function getImportStatus(importKey: string, toastId: string) {
  try {
    const response = await AxiosAuth.get<
      ApiResponseContainer<ApiSchemaGetImportStatus>
    >(AppRouteApi.Import.Status(importKey));
    switch (response?.data.data?.status) {
      case "Succeeded":
        toaster.remove(toastId);
        setTimeout(
          () => showToast("Saved successfully", "success", "topCenter"),
          1000
        );
        return false;
      case "Pending":
        return true;
      case "Failed":
        toaster.remove(toastId);
        setTimeout(
          () => showToast("Failed to save", "error", "topCenter"),
          1000
        );
        return false;
      default:
        return false;
    }
  } catch (error: any) {
    const defaultMessage = "An error occurred!";
    const errorMessage = JSON.parse(error?.message);
    showToast(errorMessage?.data?.message || defaultMessage, "error");
  }
}

function shortPollImportStatus(importKey: string, toastId: string) {
  const timeoutId = window.setInterval(() => {
    getImportStatus(importKey, toastId).then((continuePolling) => {
      !continuePolling && window.clearInterval(timeoutId);
    });
  }, 10000);
}

export const ApiDataImport = {
  saveTemplateData,
  shortPollImportStatus,
};
